module.exports = __webpack_public_path__ + "img/1-2.1c8ca0d8.svg";